import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import qs from 'qs';
import _ from 'lodash';
import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import AuthorizeRecordsTable from './mixin/authorize-records-table.js';
import RechargeDialog from './recharge-dialog/index.vue';
import RefundDialog from './recharge-dialog/refund-dialog.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import { grantRechargeList } from '@/api/grant/grant';
import { format } from 'date-fns';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import AuthorizeFilterList from './mixin/authorize-filter-list';
import { cookRequestParams } from '@/common/request';

var defaultQuery = {
  page: 1,
  page_size: 15,
  search_field: 'username_3s',
  keyword: '',
  time: [],
  status: [],
  money_min: '',
  money_max: '',
  order: '-created_time',
  export: 0,
  is_test: ''
};

export default {
  components: {
    SearchBar: SearchBar,
    RechargeDialog: RechargeDialog,
    RefundDialog: RefundDialog,
    Pagination: Pagination,
    TableList: TableList
  },
  mixins: [searchMixin, AuthorizeRecordsTable, AuthorizeFilterList],
  data: function data() {
    return {
      listLoading: true,
      query: _extends({}, defaultQuery),
      pagination: {
        total: 0
      },
      // 表单数据
      list: [],
      addDialog: {
        visible: false
      },
      refundDialog: {
        visible: false,
        id: 0,
        money: 0
      }
    };
  },

  computed: {
    exportButtonAttrs: function exportButtonAttrs() {
      return {
        icon: 'el-icon-fa-download',
        type: 'primary'
      };
    }
  },
  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.getRechargeList(this.query);
    }
  },
  methods: {
    handleSortChange: function handleSortChange(sort) {
      if (sort.order === 'descending') {
        this.query.order = '-created_time';
      } else if (sort.order === 'ascending') {
        this.query.order = 'created_time';
      } else {
        this.query.order = '';
      }
      this.getRechargeList(this.query);
    },
    getRechargeList: function getRechargeList(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.listLoading = true;
                _context.next = 4;
                return grantRechargeList(_extends({}, params));

              case 4:
                res = _context.sent;

                _this.listLoading = false;

                if (!(res.status !== 200)) {
                  _context.next = 9;
                  break;
                }

                _this.$message.error('出错了');
                return _context.abrupt('return');

              case 9:
                _this.list = _this.cookList(res);
                _this.pagination.total = _.get(res, 'data.data.total');
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                _this.listLoading = false;
                console.log(_context.t0);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    },
    exportSheet: function exportSheet() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  params = _extends({}, _this2.query, {
                    export: 1
                  });

                  downloadWithNewWindow(v2Host + '/grant/recharge/list?' + qs.stringify(_extends({}, cookRequestParams(params))));
                } catch (error) {
                  console.log(error);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showAddDialog: function showAddDialog() {
      this.addDialog.visible = true;
    },
    showRefundDialog: function showRefundDialog(id, money) {
      this.refundDialog.visible = true;
      this.refundDialog.id = id;
      this.refundDialog.money = money;
    },
    cookList: function cookList(res) {
      var list = (_.get(res, 'data.data.list') || []).map(function (item) {
        return _extends({}, item, {
          updated_time: format(item.updated_time * 1000, 'YYYY-MM-DD HH:mm:ss'),
          created_time: format(item.created_time * 1000, 'YYYY-MM-DD HH:mm:ss'),
          plan_name: '充值消耗',
          real_money: (item.money - item.refund_money).toFixed(2)
        });
      });

      return list;
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.getRechargeList(this.query);
    },
    handleReload: function handleReload() {
      this.getRechargeList(this.query);
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.getRechargeList(_this3.query);

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};